<template>
  <div class="table-main-search-field d-flex" :class="{removeSearch}">
    <div class="d-flex table-search-wrapper">
      <input class="flex-grow-1 p-2" v-model.trim="str" :placeholder="placeholder">

      <div v-if="!removeSearch" class="icon-wrapper flex-shrink-0 p-2 d-flex justify-content-center align-items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 48 48">

        <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
            <circle cx="5.92" cy="5.92" r="5.42" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></circle>
            <line x1="13.5" y1="13.5" x2="9.75" y2="9.75" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
          </g></g></svg>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: String,
    removeSearch: Boolean,
    placeholder: {
      type: String,
      default: "Zoeken",
    },
  },
  data() {
    return {
      str: this.value,
    }
  },
  watch: {
    str(val) {
      this.$emit("input", val)
    },
    value(val) {
      this.str = val
    },
  },
}

</script>

<style scoped>

.icon-wrapper {
  position: relative;
  border-left: 1px solid rgba(0, 0, 0, 0.125);
  color: #999999;
}

.table-search-wrapper {
  flex-grow: 1;
}


.table-main-search-field {
  max-width: 300px;
  background-color: white;
  border-radius: 1px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  font-size: 13px;
}

input {
  color: #6D6E71;
  padding-left: 12px !important;
  padding-right: 12px !important;
}

@media (max-width: 800px) {
  .table-main-search-field {
    max-width: unset;
    width: 100%;
  }
}

</style>
